<template>
	<div>

		<div class="knd-legend">
			<h2>Bekijk de waterkwaliteit bij jou in de buurt</h2>
			<div class="knd-legend-items">
				<div class="knd-legend-item">
					<div class="knd-legend-marker">
						<img :src="getMarkerCode('meetpunten')" alt="SVG Marker" />
					</div>
					<div class="knd-legend-text">
						<p>Meetpunt</p>
					</div>
				</div>
				<div class="knd-legend-item">
					<div class="knd-legend-marker">
						<img :src="getMarkerCode('zwemplekken')" alt="SVG Marker" />
					</div>
					<div class="knd-legend-text">
						<p>Officiële zwemlocatie</p>
					</div>
				</div>
			</div>
		</div>

		<div class='knd-map'>		

			<div 
				class="knd-map__map" 
				ref="map"></div>

			<div id="tooltip" class="knd-tooltip">
				<div v-if='tooltipInfo && tooltipLaag === "meetpunten"'>
					<p class="knd-meetpunt-kop" v-html='tooltipInfo["Omschrijving"]'></p>

					<div class="knd-stofjes">
						<div class="knd-stofjes-tussenkop"  v-if='hasVisibleStoffenJGM'>
							Gemiddelde:
						</div>
						<div class="knd-stofje" v-for="stofje in stoffen" :key="stofje">
							<div
								class="knd-tooltip-indicator"
								v-if='checkVisibilityStofje(stofje, tooltipInfo, "jgm")'
								:style='{ backgroundColor: getColor(tooltipInfo["jgm_perc_van_norm_" + stofje]) }'>
							</div>
							<div 
								v-if='checkVisibilityStofje(stofje, tooltipInfo, "jgm")'>
								{{ getStofje(stofje) }}: 
								<span v-html='getValuePerc(tooltipInfo["jgm_perc_van_norm_" + stofje])'></span>
								keer de norm
							</div>
						</div>
					</div>

					<div class="knd-stofjes">
						<div class="knd-stofjes-tussenkop" v-if='hasVisibleStoffenPiek'>
							Piek:
						</div>
						<div class="knd-stofje" v-for="stofje in stoffen" :key="stofje">
							<div
								class="knd-tooltip-indicator"
								v-if='checkVisibilityStofje(stofje, tooltipInfo, "piek")'
								:style='{ backgroundColor: getColor(tooltipInfo["piek_perc_van_norm_" + stofje]) }'>
							</div>
							<div 
								v-if='checkVisibilityStofje(stofje, tooltipInfo, "piek")'>
								{{ getStofje(stofje) }}: 
								<span v-html='getValuePerc(tooltipInfo["piek_perc_van_norm_" + stofje])'></span>
								keer de norm
							</div>
						</div>
					</div>
				</div>

				<div v-if='tooltipInfo && tooltipLaag === "zwemplekken"'>
					<p class="knd-zwemplek-kop" v-html='tooltipInfo["naam"]'></p>
					<div class="knd-zwemplek-status">
						<div
							class="knd-tooltip-indicator"
							:style='{ backgroundColor: getStatusColor(tooltipInfo["status"]) }'>
						</div>
						<div>
							<p>Zwemwaterkwaliteit: {{ tooltipInfo["status"] }}</p>
						</div>
					</div>
				</div>
			</div>

			<menu>
				<button
					class="knd-map__controls minus"
					v-show="showButtons"
					v-on:click="zoom(-1)">
					<img :src="require('@/assets/icons/icon-minus.svg')" />
				</button>

				<button
					class="knd-map__controls plus"
					v-show="showButtons"
					v-on:click="zoom(1)">
					<img :src="require('@/assets/icons/icon-plus.svg')" />
				</button>
			</menu>

			<div class="knd-map__bron">
				<p class="subtext">Bron: Informatiehuis Water, zwemwater.nl</p>
			</div>
		</div>
	</div>
</template>

<script>
	import 'ol/ol.css';
	import Map from 'ol/Map';
	import View from 'ol/View';
	import TileLayer from 'ol/layer/Tile';
	import OSM from 'ol/source/OSM';
	import VectorLayer from 'ol/layer/Vector';
	import VectorSource from 'ol/source/Vector';
	import XYZ from 'ol/source/XYZ';
	import {fromLonLat} from 'ol/proj';
	import * as interaction from 'ol/interaction';
	import {defaults} from 'ol/interaction';
	import olms from 'ol-mapbox-style';
	import Style from 'ol/style/Style';
	import Feature from 'ol/Feature';
	import Point from 'ol/geom/Point';
	import Icon from 'ol/style/Icon';
	import Polygon from 'ol/geom/Polygon';
	import MultiPolygon from 'ol/geom/MultiPolygon';
	import Fill from 'ol/style/Fill';
	import Stroke from 'ol/style/Stroke';
	import {getVectorContext} from 'ol/render';
	import Observable from 'ol/Observable';
	import TopoJSON from 'ol/format/TopoJSON';
	import Overlay from 'ol/Overlay';
	// import Attribution from 'ol/control/Attribution';
	import TileJSON from 'ol/source/TileJSON';
	import { defaults as defaultControls, Attribution } from 'ol/control';

	// https://api.maptiler.com/maps/positron/style.json?key=zwDdTky2Uwh9rxBaHcCN

	import * as d3 from 'd3';

	import './kaart.scss';

	export default {
		name: 'Kaart',
		props: [],
		data() {
			return {
				"map": null,
				"view": null,
				// "key": 'pk.eyJ1Ijoid2V5b25jZSIsImEiOiJja3V4c3JrZHgyOXJuMm5sbnBmeDdrZG1pIn0.xEdkptASss8kKDk1DjgxUw',
				"key": 'zwDdTky2Uwh9rxBaHcCN',
				"style_url": 'https://api.mapbox.com/styles/v1/weyonce/ckuxtguqy1qhc18my6ekpdcs6',
				"dotLayers": {
					"meetpunten": null,
					"zwemplekken": null
				},
				"stoffen": ["benzo(b)fluorantheen", "benzo[a]pyreen", "benzo[ghi]peryleen", "fluorantheen", "kwik", "lood", "pbde", "pfoa", "pfoa_som", "pfos", "pfos_som"],
				"zwemadvies": {
					"NEGATIEF_ZWEMADVIES": "#FF5262", 
					"WAARSCHUWING": "#FF5262", 
					"goed": "#00DEB2"
				},
				"tooltipLaag": null,
				"tooltipInfo": null,
				"tooltipPinned": false
			}
		},
		computed: {
			showButtons() {
				return true;
			},

			meetpunten() {
				return this.$store.getters.meetpunten;
			},

			zwemplekken() {
				return this.$store.getters.zwemplekken;
			},

			color() {
				return d3.scaleThreshold()
					.domain([101, 500]) 
					.range(["#00DEB2", "#FF5262"]); 
			},

			hasVisibleStoffenJGM(soort) {
				return this.stoffen.some(stofje => this.tooltipInfo["jgm_perc_van_norm_" + stofje]);
			},

			hasVisibleStoffenPiek(soort) {
				return this.stoffen.some(stofje => this.tooltipInfo["piek_perc_van_norm_" + stofje]);
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.initMap();
			});
		},
		watch: {
			meetpunten(newValue) {
				this.drawDots("meetpunten");
			},

			zwemplekken(newValue) {
				this.drawDots("zwemplekken");
			}
		},
		methods: {
			initMap() {
				this.view = new View({
					center: fromLonLat([5.493897172887767, 52.13437289886617]),
					zoom: 8
				});
				
				this.tooltip = new Overlay({
					element: document.getElementById('tooltip'),
					offset: [10, 0],
					positioning: 'bottom-left'
				});

				this.tiles = new TileLayer({
					source: new XYZ({
						url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/grijs/EPSG:3857/{z}/{x}/{y}.png',
						attributions: [
							'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
						],
					}),
				});

				this.map = new Map({
					controls: defaultControls({
						attribution: false, 
						zoom: false,
					}).extend([
						new Attribution({
							collapsible: false,
						}),
					]),
					target: this.$refs.map,
					view: this.view,
					interactions: interaction.defaults({mouseWheelZoom:true, dragPan: true}),
					overlays: [this.tooltip],
				});

				this.map.addLayer(this.tiles)				

				// olms(this.map, this.style_url + '?access_token=' + this.key);
				// olms(this.map, 'https://api.maptiler.com/maps/positron/style.json?key=' + this.key).then((map) => {
				// 	//something
				// 	this.drawDots("meetpunten");
				// 	this.drawDots("zwemplekken");
				// });
				

				const layerFilter = (layer) => {
					return layer === this.dotLayers["meetpunten"] || layer === this.dotLayers["zwemplekken"];
				}

				const calculateMapUnits = (coordinate, pixelOffset) => {
					let pixelAtCursor = this.map.getPixelFromCoordinate(coordinate);
					let pixelWithOffset = [pixelAtCursor[0] + pixelOffset[0], pixelAtCursor[1] + pixelOffset[1]];

					let coordinateWithOffset = this.map.getCoordinateFromPixel(pixelWithOffset);
					
					return [coordinateWithOffset[0] - coordinate[0], coordinateWithOffset[1] - coordinate[1]];
				}

				const getCoordinate = (cursorPosition, coordinate) => {
					let size = this.map.getSize();
					let height = size[1];
					let width = size[0];
					let cursorX = cursorPosition[0];
					let cursorY = cursorPosition[1];

					let tooltipElement = this.tooltip.getElement();
					let tooltipSize = [tooltipElement.offsetWidth, tooltipElement.offsetHeight];

					let tooltipOffsetInMapUnits = calculateMapUnits(coordinate, tooltipSize);

					if (cursorX > width / 2) {
							coordinate[0] -= tooltipOffsetInMapUnits[0];
					}

					if (cursorY < height / 2) {
							coordinate[1] += tooltipOffsetInMapUnits[1];
					}

					return coordinate;
				}

				this.map.on('pointermove', (evt) => {
					if (!this.tooltipPinned) {  
						let feature = this.map.forEachFeatureAtPixel(evt.pixel, (f) => f, {layerFilter});
						let tooltipElement = this.tooltip.getElement();

						if (feature) {
							this.tooltip.setPosition(getCoordinate(this.map.getEventPixel(evt.originalEvent), evt.coordinate));
							tooltipElement.style.display = 'block'; 

							this.tooltipLaag = feature.get('laag');
							this.tooltipInfo = feature.get('data');
						} else {
							tooltipElement.style.display = 'none';  
						}
					}
				});

				this.map.on('click', (evt) => {
					let feature = this.map.forEachFeatureAtPixel(evt.pixel, (f) => f, {layerFilter});
					let tooltipElement = this.tooltip.getElement();

					if (feature) {
						this.tooltip.setPosition(getCoordinate(this.map.getEventPixel(evt.originalEvent), evt.coordinate));
						tooltipElement.style.display = 'block';

						this.tooltipLaag = feature.get('laag');
						this.tooltipInfo = feature.get('data');
						this.tooltipPinned = true;  
					} else {
						tooltipElement.style.display = 'none';
						this.tooltipPinned = false;  
					}
				});

			},

			checkVisibilityStofje(stofje, tooltipInfo, soort) {
				if (tooltipInfo[soort + "_perc_van_norm_" + stofje]) {
					if (stofje === "pfoa" && tooltipInfo[soort + "_perc_van_norm_pfoa_som"]) {
						return false;
					}
					else if (stofje === "pfos" && tooltipInfo[soort + "_perc_van_norm_pfos_som"]) {
						return false;
					}
					// else if (this.getValuePerc(tooltipInfo[soort + "_perc_van_norm_" + stofje]) === "0,0") {
					// 	return false;
					// }
					else if (tooltipInfo["Meetobject.code"] === "NL15_OW218-215" && this.getValuePerc(tooltipInfo[soort + "_perc_van_norm_" + stofje]) === "0,0") {
						return false;
					}
					else {
						return true;
					}
				}
				else {
					return false;
				}
			},

			getStofje(stofje) {
				if (stofje === "pfoa_som") {
					return "pfoa";
				}
				else if (stofje === "pfos_som") {
					return "pfos";
				}
				else {
					return stofje;
				}
			},

			zoom(delta) {
				const zoom = this.view.getZoom();

				this.view.animate({
					duration: 300,
					zoom: zoom + delta
				});
			},

			
			drawDots(laag) {
				this.map.removeLayer(this.dotLayers[laag]);

				let features = this.makeDots(laag);

				let featureLayer = new VectorSource({
					features : features
				});

				this.dotLayers[laag] = new VectorLayer({
					className: 'dot-layer ' + laag,
					source : featureLayer
				});

				this.map.addLayer(this.dotLayers[laag]);
			},

			makeDots(laag) {
				let features = []

				this[laag].forEach((locatie, locIndex) => {
					const lonlat = fromLonLat([locatie["X"], locatie["Y"]])
					const svg = this.getMarkerCode(laag, locatie);

					const feature = new Feature({
						geometry : new Point(lonlat),
						data: locatie,
						laag: laag
					});

					feature.setStyle(new Style({
						image : new Icon({
							src : svg
						})
					}));

					features.push(feature);
				});

				return features;
			},

			getMarkerCode(laag, locatie) {
				const stroke = "none";

				let color;
				let opacity;
				let r;

				if (laag === "meetpunten") {
					color = "#00DEB2";
					opacity = 0.5;
					r = 20;

					// if (locatie && locatie["hoogste_verschil"] > 100) {
					// 	color = "#FF5262";
					// }
				}
				else {
					color = "#07034A";
					opacity = 1;
					r = 10;
				}
				
				const svg = `
				<svg version="1.0" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="` + r + `px"
					 height="` + r + `px" viewBox="0 0 ` + (r * 2) + ` ` + (r * 2) + `">
					<circle fill="${color}" stroke="${stroke}" stroke-width="3px" opacity="` + opacity + `" cx="` + r + `" cy="` + r + `" r="` + (r - 3) + `" />
				</svg>
				`;

				const base64 = window.btoa(svg);
				return `data:image/svg+xml;base64,${base64}`;
			},

			getValuePerc(perc) {
				let calc = parseFloat(perc) / 100;
				calc = calc > 2 ? calc.toFixed(0) : calc.toFixed(1)
				return calc.toString().replace(".", ",");
			},

			getColor(perc) {
				return this.color(perc);
			},

			getStatusColor(status) {
				return this.zwemadvies[status];
			}
		}
	}
</script>